import React from 'react';
import PropTypes from 'prop-types';
import posed, { PoseGroup } from 'react-pose';
import { Elements } from 'react-stripe-elements';
import { Image } from 'cloudinary-react';

import CardFields from './card-fields';
import AddressFields from './address-fields';

const FieldsPose = posed.div({
    enter: { opacity: 1, translateY: 0, duration: 1500 },
    exit: { opacity: 0, translateY: -10 },
});

class CardEntry extends React.Component {
    static propTypes = {
        shouldCollectAddress: PropTypes.bool,
        onSubmit: PropTypes.func.isRequired,
    };

    static defaultProps = {
        shouldCollectAddress: false,
    };

    state = {
        firstName: null,
        lastName: null,
        email: null,
        token: null,
        card: null,
        street1: null,
        street2: null,
        city: null,
        stateProv: null,
        zip: null,
        isShowingAddress: false,
    };

    handleCardSubmit = values => {
        const { shouldCollectAddress } = this.props;

        this.setState(values);

        // Show the address fields if they need to be collected
        if (shouldCollectAddress) {
            this.setState({ isShowingAddress: true });
            return;
        }

        // Otherwise, call submit
        this.handleSubmit();
    };

    handleAddressSubmit = values => {
        this.setState(values);
        this.handleSubmit();
    };

    handleSubmit = () => {
        const { onSubmit, shouldCollectAddress } = this.props;
        const {
            firstName,
            lastName,
            email,
            token,
            card,
            street1,
            street2,
            city,
            stateProv,
            zip,
        } = this.state;

        const data = {
            user: {
                firstName,
                lastName,
                email,
            },
            token,
            card,
        };

        if (shouldCollectAddress) {
            data.user.address = {
                street1,
                street2,
                city,
                stateProv,
                zip,
            };
        }

        return onSubmit(data);
    };

    render() {
        const { shouldCollectAddress } = this.props;
        const { isShowingAddress } = this.state;

        return (
            <div className="p-8">
                <Image publicId="app/contribution-card" alt="" className="block mx-auto mt-4" />
                <PoseGroup withParent={false} animateOnMount>
                    {!isShowingAddress ? (
                        <FieldsPose key="card">
                            <Elements>
                                <CardFields
                                    buttonLabel={
                                        shouldCollectAddress
                                            ? 'Continue to address'
                                            : 'Save and continue'
                                    }
                                    onSubmit={this.handleCardSubmit}
                                />
                            </Elements>
                        </FieldsPose>
                    ) : (
                        <FieldsPose key="address">
                            <AddressFields onSubmit={this.handleAddressSubmit} />
                        </FieldsPose>
                    )}
                </PoseGroup>
            </div>
        );
    }
}

export default CardEntry;
